import { useState, useEffect } from "react"
import { IScoreVeles, ScoreVelesKeys } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Autocomplete, Grid, TextField } from "@mui/material"
import { scoreDescriptionToLabel } from "../../../detalhes-do-projeto/filtros/score"
// Icon
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteScore = () => {
    // State
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Use State
    const [selectedScoreVeles, setSelectedScoreVeles] = useState<IScoreVeles[]>([])

    // Hook
    const { syncFilterWithForm, removeFilterFromForm } = useRecortesExtracaoService()

    useEffect(() => {
        const scoresSelecionados = createRecorteExtracaoForm.fields.Filtros?.scoreVeles || [];

        if (scoresSelecionados.length > 0) {
            setSelectedScoreVeles(scoresSelecionados);
        } else {
            setSelectedScoreVeles([]);
        }
    }, [createRecorteExtracaoForm.fields.Filtros?.scoreVeles]);

    // Filtra as opções para remover os itens já selecionados
    const filteredScores = ScoreVelesKeys.filter((score: IScoreVeles) =>
        !selectedScoreVeles.some((selected: IScoreVeles) => selected === score)
    );

    
    const handleScoreSelectionChange = (value: IScoreVeles[]) => {
        setSelectedScoreVeles(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'scoreVeles',
                value: value,
                formType: 'create'
            });
        } else {
            removeFilterFromForm({
                filtro: 'scoreVeles',
                formType: 'create'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredScores}
                    getOptionLabel={(option) => scoreDescriptionToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    value={selectedScoreVeles}
                    onChange={(event, value) => {
                        handleScoreSelectionChange(value);
                    }}
                    noOptionsText='Nenhum score encontrado'
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Opções"
                        />
                    )}
                />
            </Grid>
        </>
    )
}